import React from 'react';
import { node, string } from 'prop-types';
import styled from 'styled-components';
import { C_EBON, C_WHITE } from '@bbc/psammead-styles/colours';
import { getSansBold } from '@bbc/psammead-styles/font-styles';
import { GEL_BREVIER } from '@bbc/gel-foundations/typography';
import { detokenise, dictionaryFactory, visuallyHiddenStyle } from '../utilities';
var BORDER_WEIGHT = '0.125rem';
var GEL_SPACING_THREE_QRTS = "0.75rem";
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1mzhi2b-0"
})(["position:relative;"]);
var SkipLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "SkipLink",
  componentId: "sc-1mzhi2b-1"
})(["", " ", " background-color:", ";border:", " solid ", ";color:", ";display:block;left:0;line-height:1;padding:", ";position:absolute;text-decoration:none;top:0;z-index:10;&:not(:focus):not(:active){", "}"], function (_ref) {
  var service = _ref.service;
  return getSansBold(service);
}, GEL_BREVIER, C_WHITE, BORDER_WEIGHT, C_EBON, C_EBON, GEL_SPACING_THREE_QRTS, visuallyHiddenStyle);
var EndText = /*#__PURE__*/styled.p.withConfig({
  displayName: "EndText",
  componentId: "sc-1mzhi2b-2"
})(["", ""], visuallyHiddenStyle);

var SkipLinkWrapper = function SkipLinkWrapper(_ref2) {
  var provider = _ref2.provider,
      service = _ref2.service,
      endTextId = _ref2.endTextId,
      text = _ref2.text,
      children = _ref2.children,
      endTextVisuallyHidden = _ref2.endTextVisuallyHidden;
  var dictionary = dictionaryFactory({
    provider: provider
  });
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(SkipLink, {
    service: service,
    href: "#".concat(detokenise(endTextId, dictionary))
  }, detokenise(text, dictionary)), children, /*#__PURE__*/React.createElement(EndText, {
    tabIndex: "-1",
    id: detokenise(endTextId, dictionary)
  }, detokenise(endTextVisuallyHidden, dictionary)));
};

SkipLinkWrapper.propTypes = {
  provider: string.isRequired,
  service: string.isRequired,
  endTextId: string.isRequired,
  children: node.isRequired,
  text: string.isRequired,
  endTextVisuallyHidden: string.isRequired
};
export default SkipLinkWrapper;